import React, { useState } from "react";
import { Link } from "react-router-dom";
import Footer from "../../../footer.js";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { FaTrashAlt, FaArrowUp, FaArrowDown } from "react-icons/fa"; // Importing icons
import Header from "../../../header/header.js";
import Navvbar from "../../../header/Navvbar.js";


function DDXAccount() {
  const [subject, setSubject] = useState("Sign Up For DDX with Hira Dental Labor");
  const [emailBody, setEmailBody] = useState("");
  const [isDocumentFormVisible, setIsDocumentFormVisible] = useState(false);
  const [isVideoFormVisible, setIsVideoFormVisible] = useState(false);  // State for video form visibility
  const [uploadedDocs, setUploadedDocs] = useState([]); // State to hold the uploaded PDFs
  const [uploadedVideos, setUploadedVideos] = useState([]); // State to hold uploaded videos

  const handleSubmit = (event) => {
    event.preventDefault();

  };

  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image"],
    ],
  };

  // Toggle the visibility of the document upload form
  const toggleDocumentForm = () => {
    setIsDocumentFormVisible(!isDocumentFormVisible);
  };

  // Toggle the visibility of the video upload form
  const toggleVideoForm = () => {
    setIsVideoFormVisible(!isVideoFormVisible);
  };

  // Handle PDF file selection and add to the uploadedDocs state
  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file && file.type === "application/pdf") {
      setUploadedDocs([...uploadedDocs, { name: file.name, file }]);
    } else {
      alert("Please upload a valid PDF file.");
    }
  };

  // Handle video file selection and add to the uploadedVideos state
  const handleVideoUpload = (e) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith("video")) {
      setUploadedVideos([...uploadedVideos, { name: file.name, file }]);
    } else {
      alert("Please upload a valid video file.");
    }
  };

  // Move the document up in the list
  const moveDocumentUp = (index) => {
    if (index > 0) {
      const newDocs = [...uploadedDocs];
      const temp = newDocs[index];
      newDocs[index] = newDocs[index - 1];
      newDocs[index - 1] = temp;
      setUploadedDocs(newDocs);
    }
  };

  // Move the document down in the list
  const moveDocumentDown = (index) => {
    if (index < uploadedDocs.length - 1) {
      const newDocs = [...uploadedDocs];
      const temp = newDocs[index];
      newDocs[index] = newDocs[index + 1];
      newDocs[index + 1] = temp;
      setUploadedDocs(newDocs);
    }
  };

  // Remove a document from the list
  const removeDocument = (index) => {
    const newDocs = uploadedDocs.filter((_, i) => i !== index);
    setUploadedDocs(newDocs);
  };

  // Move the video up in the list
  const moveVideoUp = (index) => {
    if (index > 0) {
      const newVideos = [...uploadedVideos];
      const temp = newVideos[index];
      newVideos[index] = newVideos[index - 1];
      newVideos[index - 1] = temp;
      setUploadedVideos(newVideos);
    }
  };

  // Move the video down in the list
  const moveVideoDown = (index) => {
    if (index < uploadedVideos.length - 1) {
      const newVideos = [...uploadedVideos];
      const temp = newVideos[index];
      newVideos[index] = newVideos[index + 1];
      newVideos[index + 1] = temp;
      setUploadedVideos(newVideos);
    }
  };

  // Remove a video from the list
  const removeVideo = (index) => {
    const newVideos = uploadedVideos.filter((_, i) => i !== index);
    setUploadedVideos(newVideos);
  };

  return (
    <>
      <Header />
      <Navvbar/>
      <br />
      <div style={{width: '95%',  margin: '0 auto' ,padding:"0px"}}>
        <div className="row">
          {/* Sidebar */}
          <div className="col-md-2" style={{ borderRight: "2px solid #004aad" }}>
            <h3>Promotions</h3>
            <div>
              <Link to="/Websites" style={{ display: "block", margin: "10px 0" }}>DDX Websites</Link>
              <Link to="/Ad" style={{ display: "block", margin: "10px 0" }}>DDX Ads</Link>
              <Link to="/Coupon" style={{ display: "block", margin: "10px 0" }}>DDX Coupons</Link>
              <Link to="/Widget" style={{ display: "block", margin: "10px 0" }}>Widgets</Link>
              <Link to="/action" style={{ display: "block", margin: "10px 0" }}>Links</Link>
              <Link to="/DDxAccount" style={{ display: "block", margin: "10px 0" }}>DDX Account Onboarding</Link>
            </div>
          </div>

          {/* Main Content */}
          <div className="col-md-10" style={{ padding: "20px" }}>
            <h2>DDX Account Onboarding</h2>
            <form onSubmit={handleSubmit} style={{ padding: "20px", borderRadius: "8px", backgroundColor: "#f0f0f0" }}>
              <h3 style={{ backgroundColor: "white", borderBottom: "3px solid #004aad" }}>Optin Email</h3>
              <p>
                Compose your opt-in message below. If the subject or body is left empty, a default message will be used instead.
              </p>
              <label style={{ fontWeight: "bold" }}>Subject *</label>
              <input
                type="text"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                style={{
                  display: "block",
                  width: "100%",
                  padding: "10px",
                  margin: "10px 0",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                }}
              />
              <ReactQuill
                theme="snow"
                value={emailBody}
                onChange={setEmailBody}
                modules={modules}
                placeholder="Start writing here..."
                style={{ height: "200px", margin: "10px 0" }}
              />

              {/* Document Section */}
              <div style={{ margin: "20px 0" }}>
                <h4>Document Center</h4>
                <h3 style={{ backgroundColor: "white", borderBottom: "3px solid #004aad" }}>Document Center</h3>
                <br />
                <button
                  type="button"
                  style={{
                    backgroundColor: "#004aad",
                    color: "white",
                    padding: "10px 20px",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                    marginLeft: "200px",
                  }}
                  onClick={toggleDocumentForm}
                >
                  + Add Document
                </button>

                {/* Document upload form */}
                {isDocumentFormVisible && (
                  <div style={{ marginTop: "20px" }}>
                    <div>
                      <h5 style={{ fontWeight: "bold" }}>Add Your PDF</h5>
                      <input
                        type="file"
                        accept="application/pdf"
                        style={{
                          display: "block",
                          marginBottom: "10px",
                          padding: "5px",
                          width: "100%",
                        }}
                        onChange={handleFileUpload}
                      />
                    </div>
                  </div>
                )}

                {/* Display uploaded PDFs */}
                {uploadedDocs.length > 0 && (
                  <div style={{ marginTop: "20px" }}>
                    <h5 style={{ fontWeight: "bold" }}>Uploaded PDFs</h5>
                    <ul style={{ listStyleType: "none", padding: 0 }}>
                      {uploadedDocs.map((doc, index) => (
                        <li key={index} style={{ marginBottom: "10px", display: "flex", gap: "20px", alignItems: "center" }}>
                          <span>{doc.name}</span>
                          <div style={{ display: "flex", gap: "10px" }}>
                            <button type="button" onClick={() => moveDocumentUp(index)}><FaArrowUp /></button>
                            <button type="button" onClick={() => moveDocumentDown(index)}><FaArrowDown /></button>
                            <button type="button" onClick={() => removeDocument(index)}><FaTrashAlt /></button>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>

              {/* Video Section */}
              <div style={{ margin: "20px 0" }}>
                
                <h3 style={{ backgroundColor: "white", borderBottom: "3px solid #004aad" }}>Video Center</h3>
                <br />
                <button
                  type="button"
                  style={{
                    backgroundColor: "#004aad",
                    color: "white",
                    padding: "10px 20px",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                    marginLeft: "200px",
                  }}
                  onClick={toggleVideoForm}
                >
                  + Add Video
                </button>

                {/* Video upload form */}
                {isVideoFormVisible && (
                  <div style={{ marginTop: "20px" }}>
                    <div>
                      <h5 style={{ fontWeight: "bold" }}>Add Your Video</h5>
                      <input
                        type="file"
                        accept="video/*"
                        style={{
                          display: "block",
                          marginBottom: "10px",
                          padding: "5px",
                          width: "100%",
                        }}
                        onChange={handleVideoUpload}
                      />
                    </div>
                  </div>
                )}

                {/* Display uploaded videos */}
                {uploadedVideos.length > 0 && (
                  <div style={{ marginTop: "20px" }}>
                    <h5 style={{ fontWeight: "bold" }}>Uploaded Videos</h5>
                    <ul style={{ listStyleType: "none", padding: 0 }}>
                      {uploadedVideos.map((video, index) => (
                        <li key={index} style={{ marginBottom: "10px", display: "flex", gap: "20px", alignItems: "center" }}>
                          <span>{video.name}</span>
                          <div style={{ display: "flex", gap: "10px"  }}>
                            <button type="button" onClick={() => moveVideoUp(index)}><FaArrowUp /></button>
                            <button type="button" onClick={() => moveVideoDown(index)}><FaArrowDown /></button>
                            <button type="button" onClick={() => removeVideo(index)}><FaTrashAlt /></button>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>

              <button
                type="submit"
                style={{
                  backgroundColor: "#004aad",
                  color: "white",
                  padding: "10px 20px",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                  marginLeft: "500px",
                }}
              >
                Save
              </button>
            </form>
          </div>
        </div>
      </div>
      <br /><br /><br /><br /><br /><br /><br /><br /><br />
      {/* Footer */}
      <div style={{width: '95%',  margin: '0 auto' ,padding:"0px"}}>
        <Footer />
      </div>
    </>
  );
}

export default DDXAccount;
